import {
  GET_CHAT_MESSAGES_FAILURE,
  GET_CHAT_MESSAGES_REQUEST,
  GET_CHAT_MESSAGES_SUCCESS,
  POST_MESSAGE_TO_CHAT_FAILURE,
  POST_MESSAGE_TO_CHAT_REQUEST,
  POST_MESSAGE_TO_CHAT_SUCCESS,
  RESET_SCROLL_TO_BOTTOM,
  RESET_CHAT,
  RELOAD_MESSAGES,
} from './actionTypes';

const INITIAL_STATE = {
  initialChat: true,
  loadingNewMessages: true,
  messages: [],
  sendingMessage: false,
  forceScrollToBottom: false,
};

const chatReducer = (state = INITIAL_STATE, { type, messages, message }) => {
  switch (type) {
    case GET_CHAT_MESSAGES_REQUEST:
      return { ...state, loadingNewMessages: true };
    case GET_CHAT_MESSAGES_SUCCESS:
      return {
        ...state,
        initialChat: false,
        loadingNewMessages: false,
        messages: messages.reverse(),
      };
    case GET_CHAT_MESSAGES_FAILURE:
      return { ...state, loadingNewMessages: false };
    case POST_MESSAGE_TO_CHAT_REQUEST:
      return { ...state, sendingMessage: true };
    case POST_MESSAGE_TO_CHAT_SUCCESS:
      return {
        ...state,
        sendingMessage: false,
        messages: [message, ...state.messages],
        forceScrollToBottom: true,
      };
    case POST_MESSAGE_TO_CHAT_FAILURE:
      return {
        ...state,
        sendingMessage: false,
      };
    case RESET_SCROLL_TO_BOTTOM:
      return {
        ...state,
        forceScrollToBottom: false,
      };
    case RELOAD_MESSAGES:
      return {
        ...state,
        initialChat: true,
      };
    case RESET_CHAT:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default chatReducer;
